<template>
  <jet-dialog-modal icon="fas fa-address-book" id="addressModal">
    <template #title>Address</template>
    <template #content>
      <div v-if="formAddress.customer_direct_destination">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="first_name">First Name</label>
              <input id="first_name" class="form-control" type="text" v-model="formAddress.first_name"/>
              <div v-if="formAddress.errors.first_name">{{ formAddress.errors.first_name }}</div>
            </div>
          </div>
  
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="last_name">Last Name</label>
              <input id="last_name" class="form-control" type="text" v-model="formAddress.last_name"/>
              <div v-if="formAddress.errors.last_name">{{ formAddress.errors.last_name }}</div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="company_name">Company Name</label>
              <input id="company_name" class="form-control" type="text" v-model="formAddress.company_name"/>
              <div v-if="formAddress.errors.company_name">{{ formAddress.errors.company_name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="for_user && (!for_user.first_name && !for_user.last_name)">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="first_name">First Name</label>
              <input id="first_name" class="form-control" type="text" v-model="formAddress.first_name"/>
              <div v-if="formAddress.errors.first_name">{{ formAddress.errors.first_name }}</div>
            </div>
          </div>
  
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="last_name">Last Name</label>
              <input id="last_name" class="form-control" type="text" v-model="formAddress.last_name"/>
              <div v-if="formAddress.errors.last_name">{{ formAddress.errors.last_name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!$page.props.auth.user.first_name && !$page.props.auth.user.last_name">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="first_name">First Name</label>
              <input id="first_name" class="form-control" type="text" v-model="formAddress.first_name"/>
              <div v-if="formAddress.errors.first_name">{{ formAddress.errors.first_name }}</div>
            </div>
          </div>
  
          <div class="col">
            <div class="form-group">
              <label class="mb-1" for="last_name">Last Name</label>
              <input id="last_name" class="form-control" type="text" v-model="formAddress.last_name"/>
              <div v-if="formAddress.errors.last_name">{{ formAddress.errors.last_name }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="mb-1" for="address1">Address</label>
        <GMapAutocomplete
          id="address1"
          ref="address1"
          v-model="formAddress.address1"
          class="form-control"
          placeholder="Start typing address.."
          @place_changed="getAddressData"
        />
        <div v-if="formAddress.errors.address1">{{ formAddress.errors.address1 }}</div>
      </div>
      <div class="form-group">
        <label class="mb-1" for="address2">Line 2</label>
        <input id="address2" class="form-control" type="text" v-model="formAddress.address2"/>
        <div v-if="formAddress.errors.address2">{{ formAddress.errors.address2 }}</div>
      </div>
      <div class="form-group">
        <label class="mb-1" for="city">City</label>
        <input id="city" class="form-control" type="text" v-model="formAddress.city"/>
        <div v-if="formAddress.errors.city">{{ formAddress.errors.city }}</div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <label class="mb-1" for="state">State</label>
          <select v-model="formAddress.state" class="form-control">
          <option v-for="state in this.states" :key="state.name" :value="state.code">
            {{ state.code }} - {{ state.name }}
          </option>
          </select>
          <div v-if="formAddress.errors.state">{{ formAddress.errors.state }}</div>
        </div>
        <div class="form-group col-sm-6">
          <label class="mb-1" for="postcode">Zip</label>
          <input id="postcode" class="form-control" type="text" v-model="formAddress.postcode"/>
          <div v-if="formAddress.errors.postcode">{{ formAddress.errors.postcode }}</div>
        </div>
      </div>

      <div class="row" v-if="formAddress.customer_direct_destination">
        <div class="col">
          <div class="form-group">
            <label class="mb-1" for="first_name">Email</label>
            <input id="email" class="form-control" type="text" v-model="formAddress.email"/>
            <div v-if="formAddress.errors.email">{{ formAddress.errors.email }}</div>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <label class="mb-1" for="last_name">Phone</label>
            <input id="phone" class="form-control" type="text" v-model="formAddress.phone"/>
            <div v-if="formAddress.errors.phone">{{ formAddress.errors.phone }}</div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <jet-button icon="fas fa-map-marker-alt" @click="addAddress">Add Address</jet-button>
      <jet-button data-dismiss="modal" btnStyle="danger" class="ml-2">Cancel</jet-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import JetDialogModal from '@/Jetstream/DialogModal'
  import Helpers from '@/Helpers'

  export default {
    emits: ['addAddress'],
    components: {
      JetDialogModal
    },
    props: {
      formAddress: Object,
      states: Array,
      for_user: Object
    },
    mounted() {
      $('#addressModal').on('shown.bs.modal', () => this.afterOpen())
    },
    methods: {
      afterOpen() {
        this.$refs.address1.$el.focus()
      },
      getAddressData(info) {
        const city = Helpers.getAddressComponent('locality', info)
        const state = Helpers.getAddressComponent('administrative_area_level_1', info)
        const zipcode = Helpers.getAddressComponent('postal_code', info)

        const street_number = Helpers.getAddressComponent('street_number', info)
        const route = Helpers.getAddressComponent('route', info)
        let address1 = '';
        if (street_number.length && route.length) {
          address1 = street_number[0].long_name + ' ' + route[0].short_name;
        } else if (info.name) {
          address1 = info.address
        }
        this.formAddress.address1 = address1
        document.getElementById('address1').value = address1
     
        if (city.length) this.formAddress.city = city[0].long_name
        if (state.length) this.formAddress.state = state[0].short_name
        if (zipcode.length) this.formAddress.postcode = zipcode[0].long_name
      },
      onChange() {
        this.formAddress.address1 = document.getElementById('address1').value
      },
      addAddress() {
        this.formAddress.address1 = document.getElementById('address1').value
        this.$emit('addAddress')
      }
    }
  }
</script>
